/**
 * the most naive pluralization placeholder.
 * see: FormatJS' IntlMessageFormat
 */
const pluralize = (singular: string, count: number) =>
  count === 1 ? singular : `${singular}s`;

export default pluralize;
